<template>
  <div class="row">
    <div class="col-md-8 col-12">
      <date-picker ref="datepicker" :disabled-date="optAccident" v-mask="'##-##-####'" style="width: 100%;" type="date"
        @input="handleDate"  :value="dateVal" format="DD-MM-YYYY"></date-picker>
    </div>
    <div class="col-md-4 col-12">
      <date-picker ref="timepicker"  style="width: 100%;" v-mask="'##:##'" type="time"
        @input="handleTime"  :value="timeVal" format="HH:mm"></date-picker>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { mask } from "vue-the-mask";
import { DateTimeToString } from "../../services/helper";

export default {
  directives: { mask },
  props: {
    date: Date,
    time: Date,
    optionDate: Date,
  },
  data() {
    return {
      dateVal: this.date,
      timeVal: this.time,
      optDate: this.optionDate,
    };
  },
  components: {
    DatePicker
  },
  methods: {
    optAccident(date) {
      return this.optionDate <= date;
    },
    handleDate(e) {
      this.dateVal = e;
      this.$emit("input", e)
    },
    handleTime(e) {
      this.timeVal = e;
      this.$emit("input", e)
    },
  },
  mounted() {
    const picker = this.$refs.datepicker;
    const timepicker = this.$refs.timepicker;
    if (picker && picker.$el) {
      picker.$el.onkeyup = (ev) => {
        const event = ev || window.event;
        const input = picker.$el.querySelector(
          ".mx-datepicker > .mx-input-wrapper > .mx-input"
        );
        if (input.value.length === 10) {
          timepicker.focus();
          timepicker.clear();
        }
      };
    }
  },

  watch: {
    optionDate() {
      this.optDate = this.optionDate;
    },
    date() {
      this.dateVal = this.date;
    },
    time() {
      this.timeVal = this.time;
    },

  },
};
</script>

<style scoped>

</style>